import React, { useEffect, useState } from "react";
import AdminCategoryButton from "./AdminCategoryButton";
import AdminCategoryTitle from "./AdminCategoryTitle";
import { checkSession, logout } from "../../services/Admin";
import "../Main.css";

const AdminMain = () => {
    let [sessionState, setSessionState] = useState(false);
    useEffect(() => {
        checkSession().then((res) => {
            if (res.status === 200) {
                setSessionState(true);
            }
        });
    }, []);

    const onClickLogoutButton = () => {
        logout().then((res) => {
            if (res.status === 200) {
                window.location.href = "/";
            }
        });
    };

    const image = {
        logo: require("../../images/marklogo.png"),
    };
    if (sessionState) {
        return (
            <div
                style={{
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "black",
                }}
            >
                <div
                    style={{
                        height: "100px",
                        padding: "100px",
                        paddingTop: "50px",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <div>
                        <img src={image.logo} width={300}></img>
                    </div>
                    <div className="logout_button" onClick={() => onClickLogoutButton()}>
                        {" "}
                        로그아웃{" "}
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div>
                        <AdminCategoryTitle title="알리코 소개" />
                        <AdminCategoryButton
                            name="회사 연혁 관리"
                            onClickFuntion={() => (window.location.href = `/admin/company-history`)}
                        />
                        <AdminCategoryButton
                            name="인증서 관리"
                            onClickFuntion={() => (window.location.href = `/admin/certification`)}
                        />
                    </div>

                    <div>
                        <AdminCategoryTitle title="사업분야" />
                        <AdminCategoryButton
                            name="제품 관리"
                            onClickFuntion={() => (window.location.href = `/admin/product`)}
                        />
                        <AdminCategoryButton
                            name="솔루션 관리"
                            onClickFuntion={() => (window.location.href = `/admin/solution`)}
                        />
                    </div>

                    <div>
                        <AdminCategoryTitle title="고객지원" />
                        <AdminCategoryButton
                            name="영업상담 관리"
                            onClickFuntion={() => (window.location.href = `/admin/sales?page=1`)}
                        />
                        <AdminCategoryButton
                            name="A/S상담 관리"
                            onClickFuntion={() => (window.location.href = `/admin/as?page=1`)}
                        />
                        <AdminCategoryButton
                            name="자료실 관리"
                            onClickFuntion={() => (window.location.href = `/admin/documentary?page=1`)}
                        />
                    </div>

                    <div>
                        <AdminCategoryTitle title="기타정보" />
                        <AdminCategoryButton
                            name="동영상 관리"
                            onClickFuntion={() => (window.location.href = `/admin/video?page=1`)}
                        />
                        <AdminCategoryButton
                            name="채용정보 관리"
                            onClickFuntion={() => (window.location.href = `/admin/announcement?page=1`)}
                        />
                    </div>
                </div>
            </div>
        );
    }
};

export default AdminMain;
